var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onOutside,
          expression: "onOutside",
        },
      ],
      staticClass: "stake-box",
    },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", [_vm._v(_vm._s(_vm._f("translate")("general_stake")))]),
          _vm.showPayment
            ? _c("div", { staticClass: "total-payment" }, [
                _c("input", {
                  ref: "stakeBoxPayment",
                  staticClass: "input no-spinner",
                  attrs: { type: "text", readonly: "" },
                  on: {
                    focus: function ($event) {
                      return _vm.openKeyboard($event)
                    },
                    blur: function ($event) {
                      return _vm.roundPayment()
                    },
                  },
                }),
                _c("label", [
                  _vm._v(_vm._s(_vm._f("translate")("general_stake"))),
                ]),
                _c(
                  "span",
                  { staticClass: "value", class: { highlight: _vm.focus } },
                  [_vm._v(" " + _vm._s(_vm.stake ? _vm.stake : "") + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: {
                      click: function ($event) {
                        return _vm.resetPayment()
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon icon-backspace-a" })]
                ),
              ])
            : _vm._e(),
          _vm.showKeyboard
            ? _c("Keyboard", { on: { keyboardButton: _vm.setStakeManually } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "predefined-stakes" },
        _vm._l(_vm.predefinedStakes, function (value, index) {
          return _c(
            "button",
            {
              key: index,
              staticClass: "button",
              on: {
                click: function ($event) {
                  return _vm.setPredefinedPayment(value)
                },
              },
            },
            [_vm._v(" " + _vm._s("+" + value) + " ")]
          )
        }),
        0
      ),
      _vm.showActions
        ? _c("div", { staticClass: "actions" }, [
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    return _vm.closeStakeBox()
                  },
                },
              },
              [_vm._v(_vm._s(_vm._f("translate")("general_cancel")))]
            ),
            _c(
              "button",
              {
                on: {
                  click: function ($event) {
                    return _vm.acceptPayment()
                  },
                },
              },
              [_vm._v(_vm._s(_vm._f("translate")("general_accept")))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }